import { render, staticRenderFns } from "./loginTan.vue?vue&type=template&id=0764961e&scoped=true"
import script from "./loginTan.vue?vue&type=script&lang=js"
export * from "./loginTan.vue?vue&type=script&lang=js"
import style0 from "./loginTan.vue?vue&type=style&index=0&id=0764961e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764961e",
  null
  
)

export default component.exports